import * as i0 from '@angular/core';
import { Injectable, Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import * as i3 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import { FormsModule } from '@angular/forms';
import { HttpResponse, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
import { ComponentKeys } from '@niceltd/cxone-components/shared-services';
function SpinnerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(2, 1, "cxone-components.spinner.loading"));
  }
}
function SpinnerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "span", 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", i0.ɵɵpipeBind1(2, 1, "cxone-components.spinner.loading"));
  }
}
class SpinnerService {
  constructor() {
    // A BehaviourSubject is an Observable with a default value
    this.isLoading = new BehaviorSubject(false);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SpinnerService_Factory(t) {
      return new (t || SpinnerService)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SpinnerService,
      factory: SpinnerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class SpinnerComponent {
  constructor(spinnerService) {
    this.spinnerService = spinnerService;
  }
  ngOnInit() {
    // check if there is any http request and set hidden true/false
    this.spinnerService.isLoading.subscribe(isLoadingHttpSpinner => {
      this.spinner = isLoadingHttpSpinner;
    });
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SpinnerComponent_Factory(t) {
      return new (t || SpinnerComponent)(i0.ɵɵdirectiveInject(SpinnerService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SpinnerComponent,
      selectors: [["cxone-spinner"]],
      inputs: {
        isSpinner: "isSpinner"
      },
      decls: 2,
      vars: 2,
      consts: [["class", "cxonespinner", "role", "alert", "aria-busy", "true", 4, "ngIf"], ["class", "cxonespinner-client", "role", "alert", "aria-busy", "true", 4, "ngIf"], ["role", "alert", "aria-busy", "true", 1, "cxonespinner"], ["role", "image", 1, "spinner", "spinner-bounce-middle"], ["role", "alert", "aria-busy", "true", 1, "cxonespinner-client"], ["role", "image", 1, "p-i-icon"]],
      template: function SpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SpinnerComponent_div_0_Template, 3, 3, "div", 0)(1, SpinnerComponent_div_1_Template, 3, 3, "div", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.spinner);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isSpinner);
        }
      },
      dependencies: [i2.NgIf, i3.TranslationPipe],
      styles: [".cxonespinner{position:absolute;left:50%;top:60%;transform:translate(-50%,-50%);text-align:center;z-index:5000}.cxonespinner-client{display:flex}.spinner,.spinner:before,.spinner:after{width:4px;height:20px;background-color:#007cbe;border-radius:0}.spinner{display:inline-block;position:relative}.spinner:before,.spinner:after{content:\"\";position:absolute;display:block;top:0}.spinner:before{left:-6px}.spinner:after{left:6px}@keyframes bounce-middle{0%{height:4px;margin-top:8px;margin-bottom:8px;background-color:transparent}50%{height:20px;margin-top:0;margin-bottom:0;background-color:#007cbe}to{height:4px;margin-top:8px;margin-bottom:8px;background-color:transparent}}.spinner-bounce-middle{-webkit-animation:bounce-middle .6s ease .1s infinite;animation:bounce-middle .6s ease .1s infinite}.spinner-bounce-middle:before,.spinner-bounce-middle:after{top:50%;-webkit-transform:translateY(-10px) translateZ(0);transform:translateY(-10px) translateZ(0)}.spinner-bounce-middle:before{-webkit-animation:bounce-middle .6s ease 0s infinite;animation:bounce-middle .6s ease 0s infinite}.spinner-bounce-middle:after{-webkit-animation:bounce-middle .6s ease .2s infinite;animation:bounce-middle .6s ease .2s infinite}.p-i-icon{width:20px;height:20px;display:inline-block;text-align:center;border:solid 3px rgb(0,124,190);border-radius:50%;align-self:center;margin:10px;border-bottom-color:#ededed;border-left-color:#ededed;transition-property:transform;animation-name:rotate;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-spinner',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxonespinner\" *ngIf=\"spinner\" role=\"alert\" aria-busy=\"true\">\n  <div class=\"spinner spinner-bounce-middle\" role=\"image\" [attr.alt]=\"'cxone-components.spinner.loading' | translate\"></div>\n</div>\n\n<div class=\"cxonespinner-client\" *ngIf=\"isSpinner\" role=\"alert\" aria-busy=\"true\">\n  <span class=\"p-i-icon\" role=\"image\" [attr.alt]=\"'cxone-components.spinner.loading' | translate\"></span>\n</div>\n\n",
      styles: [".cxonespinner{position:absolute;left:50%;top:60%;transform:translate(-50%,-50%);text-align:center;z-index:5000}.cxonespinner-client{display:flex}.spinner,.spinner:before,.spinner:after{width:4px;height:20px;background-color:#007cbe;border-radius:0}.spinner{display:inline-block;position:relative}.spinner:before,.spinner:after{content:\"\";position:absolute;display:block;top:0}.spinner:before{left:-6px}.spinner:after{left:6px}@keyframes bounce-middle{0%{height:4px;margin-top:8px;margin-bottom:8px;background-color:transparent}50%{height:20px;margin-top:0;margin-bottom:0;background-color:#007cbe}to{height:4px;margin-top:8px;margin-bottom:8px;background-color:transparent}}.spinner-bounce-middle{-webkit-animation:bounce-middle .6s ease .1s infinite;animation:bounce-middle .6s ease .1s infinite}.spinner-bounce-middle:before,.spinner-bounce-middle:after{top:50%;-webkit-transform:translateY(-10px) translateZ(0);transform:translateY(-10px) translateZ(0)}.spinner-bounce-middle:before{-webkit-animation:bounce-middle .6s ease 0s infinite;animation:bounce-middle .6s ease 0s infinite}.spinner-bounce-middle:after{-webkit-animation:bounce-middle .6s ease .2s infinite;animation:bounce-middle .6s ease .2s infinite}.p-i-icon{width:20px;height:20px;display:inline-block;text-align:center;border:solid 3px rgb(0,124,190);border-radius:50%;align-self:center;margin:10px;border-bottom-color:#ededed;border-left-color:#ededed;transition-property:transform;animation-name:rotate;animation-duration:2s;animation-iteration-count:infinite;animation-timing-function:linear}@keyframes rotate{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"]
    }]
  }], () => [{
    type: SpinnerService
  }], {
    isSpinner: [{
      type: Input
    }]
  });
})();
class SpinnerInterceptor {
  constructor(spinnerService) {
    this.spinnerService = spinnerService;
    this.requests = [];
  }
  removeRequest(req) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.spinnerService.isLoading.next(this.requests.length > 0);
  }
  intercept(req, next) {
    this.requests.push(req);
    this.spinnerService.isLoading.next(true);
    return new Observable(observer => {
      const subscription = next.handle(req).subscribe(event => {
        if (event instanceof HttpResponse) {
          this.removeRequest(req);
          observer.next(event);
        }
      }, err => {
        this.removeRequest(req);
        observer.error(err);
      }, () => {
        this.removeRequest(req);
        observer.complete();
      });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SpinnerInterceptor_Factory(t) {
      return new (t || SpinnerInterceptor)(i0.ɵɵinject(SpinnerService));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SpinnerInterceptor,
      factory: SpinnerInterceptor.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerInterceptor, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SpinnerService
  }], null);
})();
class SpinnerModule {
  /** @nocollapse */static {
    this.ɵfac = function SpinnerModule_Factory(t) {
      return new (t || SpinnerModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SpinnerModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }, {
        provide: HTTP_INTERCEPTORS,
        useClass: SpinnerInterceptor,
        multi: true
      }],
      imports: [CommonModule, FormsModule, TranslationModule, HttpClientModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerModule, [{
    type: NgModule,
    args: [{
      declarations: [SpinnerComponent],
      imports: [CommonModule, FormsModule, TranslationModule, HttpClientModule, TranslationModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }, {
        provide: HTTP_INTERCEPTORS,
        useClass: SpinnerInterceptor,
        multi: true
      }],
      exports: [SpinnerComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SpinnerComponent, SpinnerModule, SpinnerService };
